import type { Role } from '@takeshape/schema';

export const userOnlyRoles = ['admin', 'editor', 'viewer'];
export const apiKeyOnlyRoles = ['read', 'readWrite'];
export const meshOnlyRoles = ['meshRead', 'meshReadWrite'];
export const isApiKeyOnlyRole = (role: Role): boolean => apiKeyOnlyRoles.some((r: string) => r === role.name);
export const isMeshOnlyRole = (role: Role): boolean => meshOnlyRoles.some((r: string) => r === role.name);
export const isUserOnlyRole = (role: Role): boolean => userOnlyRoles.some((r: string) => r === role.name);
